var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShortlist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.687 0.0143887C17.2924 0.119325 18.6659 0.782354 19.4134 1.45767C21.2232 3.09258 22.0195 4.91932 21.9996 6.81304C21.9803 8.66166 21.1846 10.4444 20.0804 12.0472C17.8793 15.2424 14.2129 18.0622 11.6775 19.8036C11.2965 20.0653 10.7914 20.0656 10.41 19.8037C7.87657 18.0639 4.18514 15.245 1.95844 12.0518C0.84174 10.4504 0.0315074 8.66817 0.000897411 6.81889C-0.0304058 4.92772 0.755964 3.10292 2.5577 1.4698C3.26618 0.787228 4.68148 0.146159 6.28974 0.0363459C7.76918 -0.0646715 9.47416 0.277992 11.0416 1.48561C12.5848 0.283053 14.2317 -0.0807287 15.687 0.0143887ZM15.553 1.97784C14.4356 1.90481 13.1021 2.21217 11.818 3.43679C11.3883 3.84653 10.7007 3.84745 10.2701 3.43742C8.99676 2.22503 7.60793 1.91895 6.42969 1.9994C5.19102 2.08397 4.25813 2.58847 3.964 2.87633L3.94979 2.89024L3.93501 2.90359C2.49089 4.20814 1.9904 5.51895 2.01139 6.78701C2.03315 8.10167 2.61852 9.50737 3.61931 10.9426C5.49152 13.6274 8.6003 16.1117 11.0435 17.8304C13.4812 16.1131 16.5651 13.6299 18.4132 10.9472C19.4009 9.51334 19.9752 8.10817 19.989 6.79284C20.0023 5.52266 19.495 4.20944 18.0495 2.90359L18.0494 2.90353C17.6534 2.54571 16.7192 2.05407 15.553 1.97784Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortlist);
export default __webpack_public_path__ + "static/media/Shortlist.9e7647940b1b3d1e025379e63b992b72.svg";
export { ForwardRef as ReactComponent };